// 这里注释一下，没有获取真实值来判断是否禁用
// 判断了路由有platform字眼就是认领的，认领的歌手名必须禁用
// 判断identity的是tme的机构歌手，这部分对应的各类字段也要禁用
export default (ops, props, dynamicOps) => ({
  fields1: [{
    label: '歌手头像',
    required: true,
    type: 'portrait',
    width: 500,
    height: 500,
    selfValue: ops['pic'],
    change: ops['setPic'],
    disabled: !!~props.match.params.info.indexOf('identity'),
    claimSingerId: ops['claimSingerId']
  },
  {
    label: '歌手名',
    placeholder: '请输入歌手名',
    required: true,
    type: 'text',
    selfValue: ops['name'],
    change: ops['setName'],
    disabled: !!~props.match.params.info.indexOf('platform'),
    claimSingerId: ops['claimSingerId']
  },
  {
    label: '歌手身份',
    placeholder: '请输入歌手名',
    required: true,
    type: 'select',
    selfValue: ops['identity'],
    change: ops['setIdentity'],
    dictName: 'identity',
    disabled: !!~props.match.params.info.indexOf('identity'),
  },
  {
    label: '性别',
    required: true,
    type: 'select',
    selfValue: ops['type'],
    change: ops['setType'],
    dictName: 'type',
    disabled: !!~props.match.params.info.indexOf('identity'),
  },
  {
    label: '地区',
    required: true,
    type: 'select',
    selfValue: ops['area'],
    change: ops['setArea'],
    dictName: 'area',
    disabled: !!~props.match.params.info.indexOf('identity'),
  },
  {
    label: '流派风格',
    required: true,
    type: 'select',
    selfValue: ops['genre'],
    change: ops['setGenre'],
    dictName: 'genre',
    disabled: !!~props.match.params.info.indexOf('identity'),
  },
  {
    label: '简介',
    placeholder: '个人简介（10-2000字），填写后将展示在歌手详细信息中，可参考以下内容：  \n个人信息：90后创作歌手  \n主要成就：腾讯音乐娱乐盛典最佳男/女歌手  \n代表作品：《***》',
    required: true,
    type: 'textarea',
    selfValue: ops['introduce'],
    change: ops['setIntroduce'],
    disabled: !!~props.match.params.info.indexOf('identity'),
  },{
    label: '上传站外截图（可不填）',
    //required: true,
    type: 'screenshot',
    width: 500,
    height: 500,
    // selfValue: ops['pic'],
    // change: ops['setPic'],
    // disabled: !!~props.match.params.info.indexOf('identity'),
    claimSingerId: ops['claimSingerId']
  }],
  fields3: [
    {
      label: '证件类型',
      required: true,
      type: 'select',
      selfValue: ops['credentialType'],
      change: ops['setCredentialType'],
      options: [
        { value: 0, label: '大陆身份证' },
        { value: 4, label: '居民户口簿' },
        { value: 1, label: '护照' },
        { value: 2, label: '港澳居民通行证' },
        { value: 3, label: '台湾居民通行证' },
      ],
      setCredentialHandPic: ops['setCredentialHandPic'],
      setCredentialFrontPic: ops['setCredentialFrontPic'],
      setNum: ops['setCredentialNum'],
      setName: ops['setRealName']
      // setCountryOptions: ops['setCountryOptions']
    },
    {
      label: '证件号码',
      required: true,
      type: 'text',
      placeholder: '审核通过后，证件号码不可更改',
      selfValue: ops['credentialNum'],
      change: ops['setCredentialNum'],
      // byName: ops['realName'],
      byType: ops['credentialType'],
      setCardBindPhone: ops['setCardBindPhone'],
      setIfCardBind: ops['setIfCardBind'],
      setNum: ops['setCredentialNum'],
      setName: ops['setRealName']
    },
    {
      label: '真实姓名',
      placeholder: '审核通过后，真实姓名不可修改',
      required: true,
      type: 'text',
      selfValue: ops['realName'],
      change: ops['setRealName'],
      byType: ops['credentialType']
    },
    {
      label: '实名认证',
      //placeholder: '审核通过后，真实姓名不可修改',
      required: true,
      type: 'authBtn',
      selfValue: ops['realAuthTip'],
      byType: ops['credentialType']
    },
    {
      label: '',
      //placeholder: '审核通过后，真实姓名不可修改',
      type: 'authTypeTip',
      selfValue: ops['authTypeTip'],
      byType: ops['credentialType']
    },
    // {
    //   label: '认证方式',
    //   required: true,
    //   type: 'select',
    //   selfValue: ops['authType'],
    //   change: ops['setAuthType'],
    //   options: dynamicOps && dynamicOps['authOps'] || [],
    //   setCredentialHandPic: ops['setCredentialHandPic'],
    //   setCredentialFrontPic: ops['setCredentialFrontPic'],
    //   setNum: ops['setCredentialNum'],
    //   setName: ops['setRealName']
    // },
    {
      label: '上传证件照',
      required: true,
      type: 'idcard',
      placeholder: '请上传真实有效且清晰的证件照片，照片模糊不予通过',
      selfValue: [ops['credentialFrontPic'], ops['credentialBackPic'], ops['credentialHandPic']],
      change: [ops['setCredentialFrontPic'], ops['setCredentialBackPic'], ops['setCredentialHandPic']],
      setNum: ops['setCredentialNum'],
      setName: ops['setRealName'],
      byType: ops['credentialType'],
      setCardBindPhone: ops['setCardBindPhone'],
      setIfCardBind: ops['setIfCardBind'],
      tips: ops['setShowIdCardTipsDialog']
    },
    {
      label: '国籍/地区',
      required: true,
      type: 'select',
      selfValue: ops['country'],
      change: ops['setCountry'],
      dictName: 'country'
    },
    {
      label: '手机',
      placeholder: '请输入手机号码',
      required: true,
      type: 'text',
      selfValue: ops['phone'],
      change: ops['setPhone'],
      ifModify: ops['ifModify']
    },
    {
      label: '验证码',
      placeholder: '填入验证码',
      required: true,
      type: 'authcode',
      selfValue: ops['verifyCode'],
      change: ops['setVerifyCode'],
      // 参数
      by: 16,
      phone: ops['byPhone'],
      ifModify: ops['ifModify']
    },
    {
      hide: true,
      label: '邮箱',
      placeholder: '请输入常用邮箱',
      //required: true,
      //type: 'text',
      type: null,//隐藏
      selfValue: ops['mail'],
      change: ops['setMail']
    },
    // {
    //   label: '邀请码',
    //   placeholder: '（可以不填）',
    //   type: 'text',
    //   selfValue: ops['inviteCode'],
    //   change: ops['setInviteCode'],
    //   disabled: ops['inviteCodeDisabled'],
    //   tips: ops['setShowInviteCodeTipsDialog']
    // },
  ],
  fields2: [
    {
      label: '教育水平',
      required: true,
      placeholder: '请选择教育水平',
      type: 'select',
      selfValue: ops['educationLevel'],
      change: ops['setEducationducationLevel'],
      options: [
        { value: 'juniorCollege', label: '大专' },
        { value: 'undergraduate', label: '本科' },
        { value: 'graduateStudent', label: '研究生' },
        { value: 'doctor', label: '博士' },
        { value: 'other', label: '其他' },
      ]
    },
    {
      label: '地区',
      required: true,
      placeholder: '请选择教育地区',
      type: 'select',
      selfValue: ops['schoolType'],
      change: ops['setSchoolType'],
      options: [
        { value: 'Domestic', label: '国内（不含港澳台）' },
        { value: 'HkMcTw', label: '港澳台地区' },
        { value: 'Foreign', label: '海外' },
      ]
    },
    {
      label: '就读院校',
      placeholder: '请填写就读院校',
      required: true,
      type: 'text',
      selfValue: ops['schoolName'],
      change: ops['setSchoolName'],
      dictName: 'identity',
    },
    {
      label: '毕业时间',
      required: true,
      type: 'selectTime',
      selfValue: ops['graduationTime'],
      change: ops['setGraduationTime'],
      dictName: 'identity',
    },
    {
      label: '学生证（选填）',
      required: false,
      type: 'studentID',
      selfValue: [ops['cardCover'], ops['cardContentPage'], ops['cardRegisterPage']],
      change: [ops['setCardCover'], ops['setCardContentPage'], ops['setCardRegisterPage']],
    },
  ],
})